export default function (prefix) {
  return {
    configList: prefix + '/visitorSide/leaveMessage/configList', // 留言配置
    saveLeave: prefix + '/visitorSide/leaveMessage/saveLeave', // 保存留言
  }
}
